import React from 'react'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

const Loading = ({ show }) => (
    show ? (
        <Backdrop open={show} sx={{ zIndex: 1400, backgroundColor: 'rgba(18, 24, 38, 0.35)' }}>
            <CircularProgress sx={{ color: '#4B44D8' }} />
        </Backdrop>
    ) : null
)

export default Loading
